import React, { useEffect } from 'react';
import '../../../cssFiles/landingpage.scss';

import Header from '../../layouts/header'; 
import Footer from '../../layouts/footer';
import Celebration from '../../layouts/celebration';
import ProductCards from './productCards';

const plans = [
  {
    title: 'p360° Premium',
    popular: true,
    returns: '25% returns objective* over ~12 months',
    brokerage: ' ',
    price: '₹20000 + GST',
    timeLimit: "Service active until <span style='color:black;'>returns delivered</span>",
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/premium' 
  },
  // {
  //   title: 'p360° Momentum',
  //   returns: '5-10% returns objective* over 2-6 Weeks',
  //   price: '₹20000 + GST',
  //   timeLimit: 'No Time Limit',
  //   stocks: '20 Stocks',
  //   button: 'Learn More',
  //   strategy: 'Momentum Strategy',
  //   guarantee: 'No Service Guarantee',
  //   research: '360° Research Note (1 Page)',
  //   mainPage:  '/products/momentum' 

  // },
  {
    title: 'p360° Mid Term',
    returns: '20-25% returns objective* over 6-9 months',
    price: '₹15000 + GST',
    timeLimit: "Service active until <span style='color:black;'>10 stocks</span> delivered",
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (4 Pages)',
    mainPage:  '/products/midterm' 
  },
  {
    title: 'p360° Long Term',
    returns: 'More than 50% returns objective* over 1-2 years!',
    price: '₹15000 + GST',
    timeLimit: "Service active until <span style='color:black;'>5 stocks</span> delivered",
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth+Value Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (8 Pages)',
    mainPage:  '/products/longterm'  
  },
  {
    title: 'p360° Multibagger',
    popular: false,
    returns: 'More than 100% returns objective* over 2-3 years',
    price: '₹25000 + GST',
    timeLimit: "Service active until <span style='color:black;'>5 stocks</span> delivered",
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/multibagger' 
  },
];

// const plans = [
//   {
//     title: 'p360° Premium',
//     popular: true,
//     returns: '25% returns objective* over ~12 months',
//     brokerage: 'Free Brokerage & Dealer',
//     price: '₹20000 + GST',
//     timeLimit: 'Until returns are delivered',
//     stocks: 'No Stocks Limit',
//     button: 'Learn More',
//     strategy: 'Balanced Strategy',
//     guarantee: 'Service Guarantee',
//     research: 'Research Desk Access',
//     mainPage:  '/products/premium' 
//   },
//   // {
//   //   title: 'p360° Momentum',
//   //   returns: '5-10% returns objective* over 2-6 Weeks',
//   //   price: '₹20000 + GST',
//   //   timeLimit: 'No Time Limit',
//   //   stocks: '20 Stocks',
//   //   button: 'Learn More',
//   //   strategy: 'Momentum Strategy',
//   //   guarantee: 'No Service Guarantee',
//   //   research: '360° Research Note (1 Page)',
//   //   mainPage:  '/products/momentum' 

//   // },
//   {
//     title: 'p360° Mid Term',
//     returns: '20-25% returns objective* over 6-9 months',
//     price: '₹15000 + GST',
//     timeLimit: 'No Time Limit',
//     stocks: '10 Stocks',
//     button: 'Learn More',
//     strategy: 'Growth Strategy',
//     guarantee: 'No Service Guarantee',
//     research: '360° Research Reports (4 Pages)',
//     mainPage:  '/products/midterm' 
//   },
//   {
//     title: 'p360° Long Term',
//     returns: '50-100% returns objective* over 1-2 years',
//     price: '₹15000 + GST',
//     timeLimit: 'No Time Limit',
//     stocks: '5 Stocks',
//     button: 'Learn More',
//     strategy: 'Growth+Value Strategy',
//     guarantee: 'No Service Guarantee',
//     research: '360° Research Reports (8 Pages)',
//     mainPage:  '/products/longterm'  
//   },
//   {
//     title: 'p360° Multibagger',
//     popular: false,
//     returns: '100-200% returns objective* over ~2-3 years',
//     price: '₹25000 + GST',
//     timeLimit: 'No Time Limit',
//     stocks: '5 Stocks',
//     button: 'Learn More',
//     strategy: 'Balanced Strategy',
//     guarantee: 'Service Guarantee',
//     research: 'Research Desk Access',
//     mainPage:  '/products/multibagger' 
//   },
// ];

const LandingPage = () => {

  useEffect(() => {
    document.title = "Niveza - Investment Plans";
  }, []);

  return (
    <div>
        <Header />
        <Celebration/>
        <ProductCards plans={plans}/>
        {/* <div  className="landing-container">
            <div className="cards-row">
            {plans.map((plan, idx) => (
                <div className={`card${plan.popular ? ' popular' : ''}`} key={plan.title}>
                {plan.popular && <div className="popular-badge">Most Popular</div>}
                <h2>{plan.title}</h2>
                <p className="landing_page_returns">{plan.returns}</p>
                <><br/><br/></>
                <div className="price-section">
                    <span className="price">{plan.price}</span>
                    <span className="capital">{plan.stocks}</span>
                </div>
                {plan.timeLimit && <p className="stocks">{plan.timeLimit}</p>}
                <Link to={plan.mainPage}><button className="learn-btn">{plan.button}</button></Link>
                </div>
            ))}
            </div>
        </div> */}
        <p style={{textAlign: 'center',fontFamily:'bold',color:'grey',fontSize:'0.8rem'}}>*Investments in stocks are subject to market risk. There is no assurance or gaurantee that objectives of the products on this site will be achieved.</p>

        <Footer />
    </div>
  )
};

export default LandingPage;